import type { FC } from 'react';

import BareMetalClusters, { type BareMetalClustersProps } from './Caas/BareMetalClusters';
import OpenstackClusters, { type OpenstackClustersProps } from './Caas/OpenstackClusters';
import CloudReport, { type CloudReportProps } from './CloudReport';
import OsProjects, { type OsProjectsProps } from './Compute/OsProjects';
import Users, { type UsersProps } from './Users';

// Discriminated union types
interface OsProjectsTabConfig {
  name: string;
  textId: string;
  Component: FC<OsProjectsProps>;
}

interface OpenstackClustersTabConfig {
  name: string;
  textId: string;
  Component: FC<OpenstackClustersProps>;
}

interface BareMetalClustersTabConfig {
  name: string;
  textId: string;
  Component: FC<BareMetalClustersProps>;
}

interface UsersTabConfig {
  name: string;
  textId: string;
  Component: FC<UsersProps>;
}

interface CloudReportTabConfig {
  name: string;
  textId: string;
  Component: FC<CloudReportProps>;
}

type TabConfig =
  | OsProjectsTabConfig
  | UsersTabConfig
  | OpenstackClustersTabConfig
  | BareMetalClustersTabConfig
  | CloudReportTabConfig;

interface ProductDetailsContentMap {
  compute: TabConfig[];
  evaluation: TabConfig[];
  caasonopenstack: TabConfig[];
  caasonbaremetal: TabConfig[];
  baremetal: TabConfig[];
}

// Component wrappers with inferred types
const OsProjectsWrapper: FC<OsProjectsProps> = props => <OsProjects {...props} />;
const OpenstackClustersWrapper: FC<OpenstackClustersProps> = props => (
  <OpenstackClusters {...props} />
);
const BareMetalClustersWrapper: FC<BareMetalClustersProps> = props => (
  <BareMetalClusters {...props} />
);
const UsersWrapper: FC<UsersProps> = props => <Users {...props} />;
const CloudReportWrapper: FC<CloudReportProps> = props => <CloudReport {...props} />;

const ProductDetailsContent: ProductDetailsContentMap = {
  compute: [
    { name: 'osprojects', textId: 'osProjects', Component: OsProjectsWrapper },
    { name: 'users', textId: 'users', Component: UsersWrapper },
    { name: 'cloudreport', textId: 'cloudReport', Component: CloudReportWrapper },
  ],
  evaluation: [
    { name: 'osprojects', textId: 'osProjects', Component: OsProjectsWrapper },
    { name: 'users', textId: 'users', Component: UsersWrapper },
    { name: 'cloudreport', textId: 'cloudReport', Component: CloudReportWrapper },
  ],
  caasonopenstack: [
    { name: 'clusters', textId: 'clusters', Component: OpenstackClustersWrapper },
    { name: 'users', textId: 'users', Component: UsersWrapper },
    { name: 'cloudreport', textId: 'cloudReport', Component: CloudReportWrapper },
  ],
  caasonbaremetal: [
    { name: 'clusters', textId: 'clusters', Component: BareMetalClustersWrapper },
    { name: 'users', textId: 'users', Component: UsersWrapper },
  ],
  baremetal: [{ name: 'users', textId: 'users', Component: UsersWrapper }],
};

export default ProductDetailsContent;
